let mainModulePromise: Promise<typeof import("react-phone-number-input")> | null = null;

export const getPhoneNumberLib = () => {
  if (!mainModulePromise) {
    mainModulePromise = import("react-phone-number-input");
  }
  return mainModulePromise;
};
